import { render, staticRenderFns } from "./Phq9.vue?vue&type=template&id=976bf4ea&scoped=true&"
import script from "./Phq9.vue?vue&type=script&lang=ts&"
export * from "./Phq9.vue?vue&type=script&lang=ts&"
import style0 from "./Phq9.vue?vue&type=style&index=0&id=976bf4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976bf4ea",
  null
  
)

export default component.exports